import en from "./en.json"
import ar from "./ar.json"

export const Lang = { en, ar }
